import { AppInventoryOption, type AppInventoryState } from '@openx/types/targeting/appInventory.ts';

export const getSelectedOptionsCount = (targetingParams: AppInventoryState | null) => {
  if (!targetingParams) return 0;

  const optionsToCheck = [
    {
      key: AppInventoryOption.APP_BUNDLE_ID,
      isSelected: (option: (typeof targetingParams)[typeof AppInventoryOption.APP_BUNDLE_ID]) =>
        !!option.inventorylist_id,
    },
    {
      key: AppInventoryOption.APP_BUNDLE_ID,
      isSelected: (option: (typeof targetingParams)[typeof AppInventoryOption.APP_BUNDLE_ID]) =>
        Object.keys(option.val || {}).length > 0,
    },
    {
      key: AppInventoryOption.APP_GROUP,
      isSelected: (option: (typeof targetingParams)[typeof AppInventoryOption.APP_GROUP]) =>
        Object.keys(option?.val || {}).length > 0,
    },
  ] as const;

  return optionsToCheck.reduce((count, { key, isSelected }) => {
    const option = targetingParams[key];

    return count + (option && isSelected(option) ? 1 : 0);
  }, 0);
};
